import { z } from "zod";

// ---------------------------------------------------------------------------
// Integration connection status
// ---------------------------------------------------------------------------

export const integrationStatuses = [
  "active",
  "disconnected",
  "error",
  "reauth_required",
] as const;

export const syncStatuses = ["success", "partial", "failed"] as const;

// ---------------------------------------------------------------------------
// Integration connection schema (DB row → API response)
// ---------------------------------------------------------------------------

export const IntegrationConnectionSchema = z.object({
  id: z.string().uuid().describe("ID"),
  source: z.string().describe("Source"),
  status: z.enum(integrationStatuses).describe("Status"),
  external_account_id: z.string().nullable().describe("External Account ID"),
  last_sync_at: z.string().datetime().nullable().describe("Last Sync"),
  last_sync_status: z.string().nullable().describe("Last Sync Status"),
  connected_at: z.string().datetime().describe("Connected"),
});
export type IntegrationConnection = z.infer<typeof IntegrationConnectionSchema>;

// ---------------------------------------------------------------------------
// Integration sync log schema
// ---------------------------------------------------------------------------

export const IntegrationSyncLogSchema = z.object({
  id: z.string().uuid().describe("ID"),
  connection_id: z.string().uuid().describe("Connection"),
  sync_type: z.string().describe("Sync Type"),
  entity_type: z.string().nullable().describe("Entity Type"),
  status: z.string().describe("Status"),
  records_fetched: z.number().describe("Records Fetched"),
  records_imported: z.number().describe("Records Imported"),
  records_failed: z.number().describe("Records Failed"),
  started_at: z.string().datetime().describe("Started"),
  completed_at: z.string().datetime().nullable().describe("Completed"),
  duration_ms: z.number().nullable().describe("Duration (ms)"),
});
export type IntegrationSyncLog = z.infer<typeof IntegrationSyncLogSchema>;

// ---------------------------------------------------------------------------
// API response schemas
// ---------------------------------------------------------------------------

export const IntegrationStatusResponseSchema = z.object({
  connection: IntegrationConnectionSchema.nullable().describe("Connection"),
  available: z.boolean().describe("Available"),
});
export type IntegrationStatusResponse = z.infer<
  typeof IntegrationStatusResponseSchema
>;

export const IntegrationConnectResponseSchema = z.object({
  auth_url: z.string().url().describe("Auth URL"),
});
export type IntegrationConnectResponse = z.infer<
  typeof IntegrationConnectResponseSchema
>;
